import React, { createContext, useState, useEffect, useContext } from 'react'
import { node } from 'prop-types'
import FormatosReanimate from '../res/formatosReanimate.js'

export const BannerContext = createContext();

export const BannerDimensionsContext = ({ children }) => {
  const [ html, setHtml ] = useState(null);
  const [ master, setMaster ] = useState(null);
  const [ assets, setAssets ] = useState([]);
  const [ custom, setCustom ] = useState([]);
  const [ listaReplicas, setListaReplicas ] = useState([]);
  const [ masterFormat, setMasterFormat ] = useState([]);
  const [ backup, setBackup ] = useState([]);
  const [ elementActive, setElementActive ] = useState();
  const [ loading, setLoading] = useState({show: false, progress: null});
  const [ replicaActive, setReplicaActive ] = useState('null');
  const [ mirrorActive, setMirrorActive ] = useState(true);
  const [ propertiesActive, setPropertiesActive ] = useState(true);
  const [ openFormatsHorizontal, setOpenFormatsHorizontal ] = useState (false);
  const [ openFormatsVertical, setOpenFormatsVertical ] = useState (false);
  const [ openFormatsMobile, setOpenFormatsMobile ] = useState (false);
  const [ openFormatsQuadrado, setOpenFormatsQuadrado ] = useState (false);
  const [ openFormatsCustom, setOpenFormatsCustom ] = useState (false);
  const [ openCategoryCustom, setOpenCategoryCustom ] = useState (false);
  const [ openFormats, setOpenFormats ] = useState (true);
  const [ openFormatsHTML, setOpenFormatsHTML ] = useState (false);
  const [ openFormatsVideo, setOpenFormatsVideo ] = useState (false);
  const [ openFormatsRetail, setOpenFormatsRetail ] = useState (false);
  const [ openReplicaContainer, setOpenReplicaContainer ] = useState (false);
  const [ toolinfo, setToolinfo ] = useState(null);
  const [ backgroundStage, setBackgroundStage ] = useState(true);
  const [ layoutStage, setLayoutStage ] = useState(false);
  const [ toolinfoActive, setToolinfoActive ] = useState(false);
  const [ grid, setGrid ] = useState(false);
  const [ language, setLanguage ] = useState("pt");
  const [ theme, setTheme ] = useState("light");
  const [ error, setError ] = useState({error: false, status: ""});
  const [ message, setMessage ] = useState({message: false, status: ""});
  const [ showStep, setShowStep ] = useState([]);
  const [ showMenu, setShowMenu ] = useState(true);
  const [ showStages, setShowStages ] = useState(true);
  const [ fullScreenLeft, setFullScreenLeft ] = useState(false);
  const [ fullScreenRight, setFullScreenRight ] = useState(true);
  const [ videoModal, setVideoModal ] = useState(false);
  const [ editGrid, setEditGrid ] = useState(false);
  const [ tempLine, setTempLine ] = useState(null);
  const [ customGrid, setCustomGrid ] = useState([]);
  const [ isBannerActive, setIsBannerActive ] = useState(false);
  const [ modalSeed, setModalSeed ] = useState(false);
  const [ printing, setPrinting ] = useState(false);
  const [ printStages, setPrintStages ] = useState(false);
  const [ isIABFormat, setIsIABFormat ] = useState(false);
  const [ isIABWeight, setIsIABWeight ] = useState(false);
  const [ isGloboFormat, setIsGloboFormat ] = useState(false);
  const [ isGloboWeight, setIsGloboWeight ] = useState(false);
  const [ globoWeightHosted, setGloboWeightHosted ] = useState('');
  const [ globoWeightTag, setGloboWeightTag ] = useState('');
  const [ stagesActive, setStagesActive ] = useState(true);
  const [ complianceActive, setComplianceActive ] = useState(false);
  const [ previewGridActive, setPreviewGridActive ] = useState(false);
  const [ previewGridHorizontal, setPreviewGridHorizontal ] = useState(true);
  const [ replicate, setReplicate ] = useState([]);
  /**
   * @var {'png' | 'jpg'}
   */
  const [ imageFormat, setImageFormat ] = useState('png');
  const [ previewZoomToSteps, setPreviewZoomToSteps ] = useState(false);

  useEffect(() => {
    try {
      const steps = [];
      for (var i = 1; i < master.elements[master.elements.length - 1].step + 1; i++) {
        const stepElements = [];
        for (var j = 0; j < master.elements.length; j++) {
          if (master.elements[j].step === i) stepElements.push(master.elements[j].id);
        }
        steps.push({elements: stepElements, show: true, name: `Step ${i}`});
      }
      setShowStep(steps);
    } catch {}
  }, [master])
  
  
  useEffect(() => {
    setEditGrid(false);
  }, [replicaActive]);
  
  return (
    <BannerContext.Provider
      value={{
        html, setHtml,
        master, setMaster,
        replicate, setReplicate,
        listaReplicas, setListaReplicas,
        masterFormat, setMasterFormat,
        backup, setBackup,
        loading, setLoading,
        replicaActive, setReplicaActive,
        mirrorActive, setMirrorActive,
        propertiesActive, setPropertiesActive,
        custom, setCustom,
        openFormatsHorizontal, setOpenFormatsHorizontal,
        openFormatsVertical, setOpenFormatsVertical,
        openFormatsMobile, setOpenFormatsMobile,
        openFormatsQuadrado, setOpenFormatsQuadrado,
        openFormatsCustom, setOpenFormatsCustom,
        openCategoryCustom, setOpenCategoryCustom,
        openFormatsHTML, setOpenFormatsHTML,
        openFormatsVideo, setOpenFormatsVideo,
        openFormatsRetail, setOpenFormatsRetail,
        openFormats, setOpenFormats,
        fullScreenLeft, setFullScreenLeft,
        fullScreenRight, setFullScreenRight,
        openReplicaContainer, setOpenReplicaContainer,
        toolinfo, setToolinfo,
        language, setLanguage,
        theme, setTheme,
        error, setError,
        message, setMessage,
        toolinfoActive, setToolinfoActive,
        grid, setGrid,
        elementActive, setElementActive,
        backgroundStage, setBackgroundStage,
        layoutStage, setLayoutStage,
        showStep, setShowStep,
        showMenu, setShowMenu,
        showStages, setShowStages,
        videoModal, setVideoModal,
        editGrid, setEditGrid,
        customGrid, setCustomGrid,
        tempLine, setTempLine,
        isBannerActive, setIsBannerActive,
        imageFormat, setImageFormat,
        modalSeed, setModalSeed,
        printing, setPrinting,
        printStages, setPrintStages,
        isIABFormat, setIsIABFormat,
        isIABWeight, setIsIABWeight,
        isGloboFormat, setIsGloboFormat,
        isGloboWeight, setIsGloboWeight,
        globoWeightHosted, setGloboWeightHosted,
        globoWeightTag, setGloboWeightTag,
        stagesActive, setStagesActive,
        complianceActive, setComplianceActive,
        previewGridActive, setPreviewGridActive,
        previewGridHorizontal, setPreviewGridHorizontal,
        previewZoomToSteps, setPreviewZoomToSteps,
        assets, setAssets
      }}
    >
      {children}
    </BannerContext.Provider>
  )
}

BannerDimensionsContext.propTypes = {
  children: node.isRequired
}
